/**
 * @file hid-report.ts
 * @description Nordic nRF54L 平台共享的 HID report 配置。
 * 这里放芯片/固件平台层共同约定，具体鼠标或底座命令仍放在 devices 下。
 */

export const VT_NRF54L_HID_REPORT = {
  outputReportId: 0x06,
  featureReportId: 0x08,
  busyAck: 0x02,
  okAck: 0x01,
} as const
